var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8C14 4.68605 11.3139 2 8 2C4.68605 2 2 4.68605 2 8C2 11.3133 4.68605 14 8 14C11.3139 14 14 11.3133 14 8Z",
    stroke: "#1976D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8C14 4.68605 11.3139 2 8 2C4.68605 2 2 4.68605 2 8C2 11.3133 4.68605 14 8 14C11.3139 14 14 11.3133 14 8Z",
    stroke: "url(#paint0_linear_3050_40582)",
    strokeOpacity: 0.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96484 10.8167V10.7979",
    stroke: "#1976D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96484 10.8167V10.7979",
    stroke: "url(#paint1_linear_3050_40582)",
    strokeOpacity: 0.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96414 9.1664C7.95634 8.5722 8.49667 8.32053 8.8982 8.09153C9.38794 7.82173 9.7194 7.39167 9.7194 6.79553C9.7194 5.9121 9.0052 5.20312 8.1276 5.20312C7.24414 5.20312 6.53516 5.9121 6.53516 6.79553",
    stroke: "#1976D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96414 9.1664C7.95634 8.5722 8.49667 8.32053 8.8982 8.09153C9.38794 7.82173 9.7194 7.39167 9.7194 6.79553C9.7194 5.9121 9.0052 5.20312 8.1276 5.20312C7.24414 5.20312 6.53516 5.9121 6.53516 6.79553",
    stroke: "url(#paint2_linear_3050_40582)",
    strokeOpacity: 0.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3050_40582",
    x1: 8,
    y1: 2,
    x2: 8,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3050_40582",
    x1: 8.46484,
    y1: 10.7979,
    x2: 8.46484,
    y2: 10.8167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3050_40582",
    x1: 8.12728,
    y1: 5.20312,
    x2: 8.12728,
    y2: 9.1664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.2cd272e664bfe0a6399153fb175e6f56.svg";
export { ForwardRef as ReactComponent };